export const STALE_TIME_10_MINUTES = 1000 * 60 * 10;
export const STALE_TIME_1_HOUR = 1000 * 60 * 60;
export const STALE_TIME_INFINITY = Infinity;
